import {
  RELATION__EMPLOYERS_STARRED
} from '../../dictionaries/Relations.dic';
import Core from "../../lib/Core";
import {
  ACCOUNT_ACTION__EDIT_EMPLOYER, STATE_ACTIVE
} from '../../lib/Definition';
import Employer from '../../lib/Employer';
import {
  mapEmployers
} from '../../lib/models/employer';
import EmployerUI from '../Employers/EmployerUI.dic';
import {
  moreMenuOptionsEmployers
} from "./3DotsMenu/moreMenuOptionsEmployers";
import {
  FilterDateRangeColumn
} from "./FilterDateRangeColumn";
import {
  FilterLocationsColumn
} from "./FilterLocationsColumn";
import {
  CellActionsColumn,
  CellTagColumn,
  FilterActionsColumn,
  FilterNumberRangeColumn,
  FilterTagColumn
} from "./ReactTable";
import {
  REACT_TABLE__COLUMN_XXL
} from "./useEnhancedReactTable.hook";

export const configEmployers = {
  Entity: Employer,
  entityMapper: mapEmployers,
  searchPath: 'Employers/_search',
  autocompletePath: 'Employers/_autocomplete',
  facetsPath: 'Employers/_facets',
  starredAccessor: 'employersStarred',
  searchPlaceholder: 'Search by Employer company name, contact name',
  addNew: () => Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_EMPLOYER }) && {
    label: '+ New Employer',
    to: '/employer/create'
  },
  defaultQuery: {
    "filters": [
      {
        "state": STATE_ACTIVE,
      }
    ],
    "skip": 0,
    "limit": 10,
    "query": [],
    "associations": [
      'jobs',
      RELATION__EMPLOYERS_STARRED
    ]
  },
  hiddenColumns: [
    'state',
  ],
  columns: [
    {
      accessor: 'name',
      Header: 'Employer Name',
      Cell: CellTagColumn,
      width: 160,
      _accessor: '_infoCmp',
      _headerClassName: 'sticky-start bg-cyan-common',
      _cellClassName: 'sticky-start bg-white-common',
    },
    {
      accessor: 'url',
      Header: EmployerUI.url.titleShort,
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      _accessor: '_urlCmp'
    },
    {
      accessor: 'primaryContactLinkedin',
      Header: EmployerUI.primaryContactLinkedin.titleShort,
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      _accessor: '_primaryContactLinkedinCmp'
    },
    {
      accessor: 'primaryContactEmail',
      Header: EmployerUI.primaryContactEmail.titleShort,
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      _accessor: '_primaryContactEmailCmp'
    },
    {
      accessor: 'crunchbaseUrl',
      Header: EmployerUI.crunchbaseUrl.titleShort,
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      _accessor: '_crunchbaseUrlCmp'
    },
    {
      accessor: 'notables',
      Header: EmployerUI.notables.titleShort,
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
    },
    {
      accessor: 'jobs.roles',
      Header: 'Job Roles',
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      _accessor: '_jobRoles',
      _categoryKey: 'roles',
    },
    {
      accessor: 'location',
      Header: 'Location',
      Filter: FilterLocationsColumn,
      //Filter: FilterTagColumn,
      Cell: CellTagColumn,
      disableSortBy: false,
      width: REACT_TABLE__COLUMN_XXL,
      _accessor: '_location',
      _categoryKey: 'location',
      _facetTagRequired: true,
    },
    {
      accessor: 'technicalSkills',
      Header: 'Technology',
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      disableSortBy: false,
      _accessor: '_technicalSkills',
      _categoryKey: 'technicalSkills',
    },
    {
      accessor: 'visaTransfer',
      Header: 'Visa',
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      disableSortBy: false,
      width: 160,
      _accessor: '_visaTransfer',
      _categoryKey: 'visa',
    },
    {
      accessor: 'stage',
      Header: 'Stage',
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      disableSortBy: false,
      _accessor: '_stage',
      _categoryKey: 'stage',
    },
    {
      accessor: 'employeeCount',
      Header: 'Employees',
      Filter: FilterNumberRangeColumn,
      Cell: CellTagColumn,
      disableSortBy: false,
      _accessor: '_employeeCount',
    },
    {
      accessor: 'careersPage',
      Header: 'Careers Page',
      Cell: CellTagColumn,
      width: 160,
      _accessor: '_careersPage',
    },
    {
      accessor: 'updatedAt',
      Header: 'Recent',
      Filter: FilterDateRangeColumn,
      width: REACT_TABLE__COLUMN_XXL,
      disableFilters: false,
      Cell: CellTagColumn,
      _accessor: '_updatedAt',
    },
    {
      accessor: 'state',
      Header: 'State',
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      disableSortBy: false,
      width: 120,
      _acl: [Core.isAdminOrCoordinator()],
      _accessor: '_state',
      _categoryKey: 'state',
    },
    {
      id: 'actions',
      Header: 'Actions',
      Filter: FilterActionsColumn,
      Cell: CellActionsColumn,
      defaultCanFilter: true,
      disableFilters: false,
      disableSortBy: false,
      width: 170,
      _starredAccessor: `${RELATION__EMPLOYERS_STARRED}.starred`,
      _headerClassName: 'sticky-end bg-cyan-common c-white-all bl-1',
      _cellClassName: 'sticky-end bg-white-common bl-1 d-flex flex-align-right-center',
    }
  ],
  moreMenuOptions: moreMenuOptionsEmployers,
};
